import defaultConfig from 'config/default-config.yaml';

import {mergeTo} from '#core/utils/config-utils.js';

import {configureSportsbook} from '#core/sportsbook-initializer.js';

import fonts from './config/fonts.yaml';
import {BASE_PALETTE} from './config/theme';
import AliraSSOService from './alira/sso-service.js';
import {getTokens} from './config/viewsconfig';
import INTENT from './config/intent';
import footer from './views/applicationfooter/index.jsx';

import '#core/features/analytics/connextra/index.js';

const isSportiumColombia = CLIENT_NAME === 'sportium-com-co';

function enrichMojitoConfigWithCustom(mojitoConfig, appConfig) {
    INTENT.init();

    mergeTo(mojitoConfig, {
        services: {
            authenticationService: {
                // only if specified in config
                ssoImplementation:
                    isSportiumColombia && appConfig.loginIntegrationBaseURL
                        ? new AliraSSOService(appConfig.loginIntegrationBaseURL)
                        : undefined,
            },
            configurations: {
                AppViewSportsbook: {
                    applicationFooter: {
                        hide: !isSportiumColombia,
                    },
                },
            },
            viewImplementations: {
                ApplicationFooter: {
                    implementation: isSportiumColombia ? footer : undefined,
                },
            },
        },
    });
}

configureSportsbook({
    enrichMojitoConfigWithCustomFn: enrichMojitoConfigWithCustom,
    getTokensFn: getTokens,
    configuration: {
        ...defaultConfig,
        appearance: {
            BASE_PALETTE,
        },
        fonts,
    },
});
